(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1987],{

/***/ 7832:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/[detail]",
      function () {
        return __webpack_require__(9184);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ CantFindWhatYouAreLooking; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_components_media_cantfindwhatyouarelooking_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6114);
/* harmony import */ var _styles_components_media_cantfindwhatyouarelooking_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_components_media_cantfindwhatyouarelooking_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7037);





const CantFindWhatYouAreLooking = ()=>{
    // these variables are used to animate the left and right image when this view are on screen.
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .useInView */ .Y)(ref, {
        once: false
    });
    /**
     * in this section user can download the pdf file of the products.
     */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_styles_components_media_cantfindwhatyouarelooking_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().you_are_looking_for),
        ref: ref,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "images ".concat(isInView ? "image_animation" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "desktop",
                        src: "/assets/images/decorations/media/media_cant_find_banner_left.webp",
                        alt: "image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "desktop",
                        src: "/assets/images/decorations/media/media_cant_find_banner_right.webp",
                        alt: "image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "ipad",
                        src: "/assets/images/decorations/media/media_cant_find_ipad_left.webp",
                        alt: "image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "ipad",
                        src: "/assets/images/decorations/media/media_cant_find_ipad_right.webp",
                        alt: "image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "mobile",
                        src: "/assets/images/decorations/media/media_cant_find_mobile_left.webp",
                        alt: "image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "mobile",
                        src: "/assets/images/decorations/media/media_cant_find_mobile_right.webp",
                        alt: "image"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: "can’t find what you’re looking for?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "description",
                dangerouslySetInnerHTML: {
                    __html: 'For all media enquiries please email us at <a href="mailto:care@sidr.com">care@sidr.com</a>'
                }
            })
        ]
    });
};


/***/ }),

/***/ 231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ YouMayAlsoLikeHoneyList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_components_you_may_also_like_honey_list_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4391);
/* harmony import */ var _styles_components_you_may_also_like_honey_list_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_components_you_may_also_like_honey_list_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




const YouMayAlsoLikeHoneyList = (param)=>{
    let { title ="" , productType: string = "" , honeyList =[]  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: honeyList && honeyList.length != 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: (_styles_components_you_may_also_like_honey_list_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product_list",
                    children: honeyList.map((item, index)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "item item_honey",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/products/detail/".concat(item.attributes.Collection.data.attributes.Link, "/") + item.attributes.Shopify_Link,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        loading: "lazy",
                                        className: "img_honey",
                                        src: item.attributes.Image.data.attributes.url,
                                        alt: item.attributes.Image.data.attributes.alternativeText
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "bar_line bar_line_honey"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: item.attributes.Title
                                    })
                                ]
                            })
                        }, "product-" + index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {})
            ]
        })
    });
};


/***/ }),

/***/ 1903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ MediaImageSliderData; }
/* harmony export */ });
const MediaImageSliderData = [
    {
        imageUrl: "/assets/images/decorations/media/media_sidr_in_action_event_2.webp",
        imageAltText: "Made For Royalty",
        videoUrl: "/assets/video/media_sidr_in_action_event_2_clip.mp4",
        videoUrlWebm: "/assets/video/media_sidr_in_action_event_2_clip.webm",
        hoverTitle: "Made For Royalty"
    },
    {
        imageUrl: "/assets/images/decorations/media/media_sidr_in_action_event_3.webp",
        imageAltText: "Decorating Urban Garden"
    },
    {
        imageUrl: "/assets/images/decorations/media/media_sidr_in_action_event_1.webp",
        imageAltText: "Grab a Sapling and Let's Hiking"
    }
];


/***/ }),

/***/ 9184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_pages_media_detail_module_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5072);
/* harmony import */ var _styles_pages_media_detail_module_scss__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_media_detail_module_scss__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8116);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(719);
/* harmony import */ var _config_MediaImageSlider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1903);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6797);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3029);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_pdf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5777);
/* harmony import */ var _components_media_cantfindwhatyouarelooking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3125);
/* harmony import */ var pdfjs_dist_build_pdf_worker_entry__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9016);
/* harmony import */ var pdfjs_dist_build_pdf_worker_entry__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(pdfjs_dist_build_pdf_worker_entry__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7037);
/* harmony import */ var react_simple_typewriter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2637);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2298);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(3855);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _components_you_may_also_like_honey_list__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(231);







// Import Swiper styles




// @ts-ignore


// @ts-ignore






react_pdf__WEBPACK_IMPORTED_MODULE_9__/* .pdfjs.GlobalWorkerOptions.workerSrc */ .v0.GlobalWorkerOptions.workerSrc = (pdfjs_dist_build_pdf_worker_entry__WEBPACK_IMPORTED_MODULE_11___default());
// @ts-ignore
function Media(param) {
    let { mediaDetail , mediaList , pdfDetails , mediaStructuredData , relatedProducts  } = param;
    /**
     * Media images swiper configuration
     */ const swiperConfigImages = {
        modules: [
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W_,
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Pagination */ .tl,
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .EffectFade */ .xW,
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Autoplay */ .pt
        ],
        spaceBetween: 60.4,
        centeredSlides: true,
        centeredSlidesBounds: true,
        initialSlide: 0,
        loop: true,
        fade: "true",
        speed: 600,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 70
            },
            481: {
                slidesPerView: 1.5,
                spaceBetween: 40
            },
            768: {
                slidesPerView: 1.7,
                spaceBetween: 40
            },
            1025: {
                slidesPerView: 1.629,
                spaceBetween: 60.4
            },
            1201: {
                slidesPerView: 1.629,
                spaceBetween: 60.4
            }
        }
    };
    // News swiper instance
    const [swiperNewsRef, setSwiperNewsRef] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    /**
     * News swiper configuration
     */ const swiperConfigNews = {
        modules: [
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W_,
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Pagination */ .tl,
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .EffectFade */ .xW
        ],
        spaceBetween: 0,
        initialSlide: 1,
        centeredSlides: true,
        centeredSlidesBounds: true,
        fade: "true",
        pagination: {
            el: ".swiper-pagination-news-1"
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            481: {
                slidesPerView: 2.15,
                spaceBetween: 0,
                centeredSlides: false,
                centeredSlidesBounds: false
            },
            768: {
                slidesPerView: 2.15,
                spaceBetween: 0,
                centeredSlides: false,
                centeredSlidesBounds: false
            },
            1025: {
                slidesPerView: 3.15,
                spaceBetween: 60
            },
            1201: {
                slidesPerView: 3.922,
                spaceBetween: 60
            }
        }
    };
    /**
     * To set active page and handle the click action
     */ const [activePage, setActivePage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1);
    const handlePageChange = (pageNumber)=>{
        setActivePage(pageNumber);
        if (swiperNewsRef) {
            // @ts-ignore
            swiperNewsRef.slideTo(pageNumber);
        }
    };
    // these variables are used to animate the left and right image when this view are on screen.
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_15__/* .useInView */ .Y)(ref, {
        once: false
    });
    /**
     * Video element ref.
     */ const [activeVideoElement, setActiveVideoElement] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [isPlaying, setIsPlaying] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    /**
     * The privacy policy page contain about the company privacy policy
     * The text are managed via 3 different styles and one for list.
     */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_13___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(mediaStructuredData)
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: (_styles_pages_media_detail_module_scss__WEBPACK_IMPORTED_MODULE_16___default().banner),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "details_container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: "sidr now"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "title_text",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_typewriter__WEBPACK_IMPORTED_MODULE_12__/* .Typewriter */ .rf, {
                                words: [
                                    "latest media",
                                    "launches",
                                    "events",
                                    "partnerships"
                                ],
                                loop: true,
                                typeSpeed: 120,
                                deleteSpeed: 90,
                                delaySpeed: 1500
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: (_styles_pages_media_detail_module_scss__WEBPACK_IMPORTED_MODULE_16___default().container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                children: mediaDetail.Title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: "media_detail",
                                dangerouslySetInnerHTML: {
                                    __html: mediaDetail.Detail
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_you_may_also_like_honey_list__WEBPACK_IMPORTED_MODULE_14__/* .YouMayAlsoLikeHoneyList */ .b, {
                title: "you may also try",
                honeyList: relatedProducts
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: (_styles_pages_media_detail_module_scss__WEBPACK_IMPORTED_MODULE_16___default().sidr_news),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, {
                    ...swiperConfigNews,
                    onSwiper: (swiper)=>{
                        // @ts-ignore
                        setSwiperNewsRef(swiper);
                    },
                    slidesPerView: "auto",
                    children: [
                        mediaList.map((item, index)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                                onClick: ()=>{
                                    handlePageChange(index);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                    href: item.attributes.Link,
                                    className: "media_item",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: item.attributes.Title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "date",
                                            children: (0,date_fns__WEBPACK_IMPORTED_MODULE_17__["default"])((0,date_fns__WEBPACK_IMPORTED_MODULE_18__["default"])(item.attributes.Date), "LLL d, yyyy")
                                        })
                                    ]
                                }, "news-" + index)
                            }, "image-" + index);
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "swiper-pagination-news",
                            children: Array(~~5).fill(0).map((_, index)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "swiper-pagination-bullet ".concat(activePage == index ? "swiper-pagination-bullet-active" : ""),
                                    tabIndex: 0,
                                    role: "button",
                                    onClick: ()=>{
                                        handlePageChange(index);
                                    },
                                    "aria-label": "Go to slide ".concat(index)
                                }, "dot-news-" + index);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: (_styles_pages_media_detail_module_scss__WEBPACK_IMPORTED_MODULE_16___default().sidr_in_action),
                ref: ref,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "title_text",
                        children: "sidr in action"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, {
                        ...swiperConfigImages,
                        slidesPerView: "auto",
                        onSlideChange: (swiper)=>{
                            if (activeVideoElement) {
                                setIsPlaying(false);
                                // @ts-ignore
                                activeVideoElement.pause();
                                // @ts-ignore
                                activeVideoElement.removeEventListener("ended", ()=>{});
                                setActiveVideoElement(null);
                            }
                        },
                        children: [
                            _config_MediaImageSlider__WEBPACK_IMPORTED_MODULE_4__/* .MediaImageSliderData.map */ .k.map((item, index)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "".concat(isPlaying ? "disable" : ""),
                                        children: item.videoUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("video", {
                                                    poster: item.imageUrl,
                                                    playsInline: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                                            src: item.videoUrl,
                                                            type: "video/mp4"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                                            src: item.videoUrlWebm,
                                                            type: "video/webm"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "play_video",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "container",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                onClick: ()=>{
                                                                    const currentDiv = document.getElementsByClassName("swiper-slide-active");
                                                                    if (currentDiv[1].children[0].children.length > 1) {
                                                                        const videoElement = currentDiv[1].children[0].children[0];
                                                                        // @ts-ignore
                                                                        setActiveVideoElement(videoElement);
                                                                        if (videoElement) {
                                                                            setIsPlaying(true);
                                                                            // @ts-ignore
                                                                            videoElement.play();
                                                                            videoElement.addEventListener("ended", ()=>{
                                                                                setIsPlaying(false);
                                                                            }, false);
                                                                        }
                                                                    }
                                                                },
                                                                src: "/assets/images/decorations/media/sidr_in_action_play_button.webp",
                                                                alt: "play"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                children: [
                                                                    "Press Video ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                    item.hoverTitle
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            loading: "lazy",
                                            src: item.imageUrl,
                                            alt: item.imageAltText
                                        })
                                    })
                                }, "image-" + index);
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "over_image_container ".concat(isInView ? "image_animation" : ""),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/assets/images/decorations/media/media_sidr_in_action.webp",
                                    alt: "sidr media"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "swiper-pagination",
                                children: _config_MediaImageSlider__WEBPACK_IMPORTED_MODULE_4__/* .MediaImageSliderData.map */ .k.map((_, index)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "swiper-pagination-bullet",
                                        tabIndex: 0,
                                        role: "button",
                                        "aria-label": "Go to slide ".concat(index)
                                    }, "dot-honey-" + index);
                                })
                            })
                        ]
                    })
                ]
            }),
            pdfDetails && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: (_styles_pages_media_detail_module_scss__WEBPACK_IMPORTED_MODULE_16___default().sidr_media_kit),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "title_text",
                        children: "media kit"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "item",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_pdf__WEBPACK_IMPORTED_MODULE_9__/* .Document */ .BB, {
                                        file: pdfDetails.Products_Catalog.data.attributes.url,
                                        options: {
                                            workerSrc: "/pdf.worker.js"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_pdf__WEBPACK_IMPORTED_MODULE_9__/* .Page */ .T3, {
                                            pageNumber: 1
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: pdfDetails.Products_Catalog.data.attributes.caption ? pdfDetails.Products_Catalog.data.attributes.caption : pdfDetails.Products_Catalog.data.attributes.alternativeText
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                        href: pdfDetails.Products_Catalog.data.attributes.url,
                                        className: "download_catalog",
                                        target: "_blank",
                                        download: pdfDetails.Products_Catalog.data.attributes.caption ? pdfDetails.Products_Catalog.data.attributes.caption : pdfDetails.Products_Catalog.data.attributes.alternativeText,
                                        children: "Download"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "item",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_pdf__WEBPACK_IMPORTED_MODULE_9__/* .Document */ .BB, {
                                        file: pdfDetails.Wordmark.data.attributes.url,
                                        options: {
                                            workerSrc: "/pdf.worker.js"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_pdf__WEBPACK_IMPORTED_MODULE_9__/* .Page */ .T3, {
                                            pageNumber: 1
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: pdfDetails.Wordmark.data.attributes.caption ? pdfDetails.Wordmark.data.attributes.caption : pdfDetails.Wordmark.data.attributes.alternativeText
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                        href: pdfDetails.Wordmark.data.attributes.url,
                                        className: "download_catalog",
                                        target: "_blank",
                                        download: pdfDetails.Wordmark.data.attributes.caption ? pdfDetails.Wordmark.data.attributes.caption : pdfDetails.Wordmark.data.attributes.alternativeText,
                                        children: "Download"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "item",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_pdf__WEBPACK_IMPORTED_MODULE_9__/* .Document */ .BB, {
                                        file: pdfDetails.Brand_Architecture.data.attributes.url,
                                        options: {
                                            workerSrc: "/pdf.worker.js"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_pdf__WEBPACK_IMPORTED_MODULE_9__/* .Page */ .T3, {
                                            pageNumber: 1
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: pdfDetails.Brand_Architecture.data.attributes.caption ? pdfDetails.Brand_Architecture.data.attributes.caption : pdfDetails.Brand_Architecture.data.attributes.alternativeText
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                        href: pdfDetails.Brand_Architecture.data.attributes.url,
                                        className: "download_catalog",
                                        target: "_blank",
                                        download: pdfDetails.Brand_Architecture.data.attributes.caption ? pdfDetails.Brand_Architecture.data.attributes.caption : pdfDetails.Brand_Architecture.data.attributes.alternativeText,
                                        children: "Download"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_media_cantfindwhatyouarelooking__WEBPACK_IMPORTED_MODULE_10__/* .CantFindWhatYouAreLooking */ .V, {})
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Media);


/***/ }),

/***/ 6114:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","you_are_looking_for":"cantfindwhatyouarelooking_you_are_looking_for__ew1HR","about-image-in":"cantfindwhatyouarelooking_about-image-in__ttUXq","fade-in-honeycomb":"cantfindwhatyouarelooking_fade-in-honeycomb__arT3W","dot-falling":"cantfindwhatyouarelooking_dot-falling__Sr4Rs","dot-falling-before":"cantfindwhatyouarelooking_dot-falling-before__QkUHC","dot-falling-after":"cantfindwhatyouarelooking_dot-falling-after__8rFxB"};

/***/ }),

/***/ 4391:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","container":"you-may-also-like-honey-list_container__9lqdX","about-image-in":"you-may-also-like-honey-list_about-image-in__5uTWH","fade-in-honeycomb":"you-may-also-like-honey-list_fade-in-honeycomb__Jx4_6","dot-falling":"you-may-also-like-honey-list_dot-falling__QFRqg","dot-falling-before":"you-may-also-like-honey-list_dot-falling-before__h6oE7","dot-falling-after":"you-may-also-like-honey-list_dot-falling-after__eoGWd"};

/***/ }),

/***/ 5072:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","banner":"detail_banner__XJsnK","container":"detail_container__gaf9t","sidr_news":"detail_sidr_news__uYSJZ","sidr_in_action":"detail_sidr_in_action___P_yP","sidr_media_kit":"detail_sidr_media_kit__PCgo1","about-image-in":"detail_about-image-in__TyBbZ","fade-in-honeycomb":"detail_fade-in-honeycomb__iYJ4d","dot-falling":"detail_dot-falling__FOelc","dot-falling-before":"detail_dot-falling-before__KkLT9","dot-falling-after":"detail_dot-falling-after__pxfKy"};

/***/ }),

/***/ 9016:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/* Copyright 2022 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(typeof window !== "undefined"
  ? window
  : {}
).pdfjsWorker = __webpack_require__(7624);


/***/ }),

/***/ 3414:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 172:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 2001:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 3779:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 2258:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4577,8153,1074,5666,9774,2888,179], function() { return __webpack_exec__(7832); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);